export default () => ({
  calculatorData: {
    carDetails: {

    },

    bankDetails: {

    },
  },

  calcFieldCf7: '',

  loading: false,
  loadingSafetyTimeout: null,

  init() {
    this.listenCalculatorLoading();
    this.listenToCalcChanges();
    this.listenToFormSubmitted();
  },

  listenCalculatorLoading() {
    window.addEventListener('calculator-started-loading', () => {
      this.loading = true;
      if (this.loadingSafetyTimeout) {
        clearTimeout(this.loadingSafetyTimeout);
      }
      this.loadingSafetyTimeout = setTimeout(() => {
        this.loading = false;
        this.loadingSafetyTimeout = null;
      }, 25000);
    });

    window.addEventListener('calculator-finished-loading', () => {
      this.loading = false;
      if (this.loadingSafetyTimeout) {
        clearTimeout(this.loadingSafetyTimeout);
        this.loadingSafetyTimeout = null;
      }
    });
  },

  listenToCalcChanges() {
    window.addEventListener('raty-calculator-changed', (e) => {
      if (! e.detail?.carDetails || !e.detail?.bankDetails) {
        return;
      }

      this.calculatorData.carDetails = e.detail.carDetails;
      this.calculatorData.bankDetails = e.detail.bankDetails;

      this.updateDetails();
      this.setCf7Fields();
    })
  },

  /**
   * After CF7 submit -- let's fill the hidden textarea with the current data, just in case
   * the user wants to submit again without changing the data in the calculator.
   */
  listenToFormSubmitted() {
    const wpcf7Elm = document.querySelector('.wpcf7');
    if (! wpcf7Elm) {
      return;
    }

    wpcf7Elm.addEventListener('wpcf7submit', (event) => {
      setTimeout(() => {
        this.updateDetails();
        this.setCf7Fields()
      }, 250)
    }, false);

  },

  updateDetails() {
    this.calcFieldCf7 = JSON.stringify(this.calculatorData);
  },

  setCf7Fields() {
    if (! this.$refs.cardetail) {
      return;
    }

    this.$refs.cardetail.value = this.calcFieldCf7;
  }
});
